import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { RouterModule } from '@angular/router';
import { AuthLayoutComponent } from './auth/auth-layout/auth-layout.component';



@NgModule({
  declarations: [MainLayoutComponent, AuthLayoutComponent],
  imports: [
   CommonModule,
    RouterModule,       
    SharedModule
  ],
  exports:[
    MainLayoutComponent
  ]})
export class CoreModule { }
